<template>
  <div class="guide">
    <div class="card-guide-body">
      <b-row>
        <b-col>
          <button-toolbar
            :items="items"
            :status="status"
            @add-item-click="handleAddItemClick"
            @status-click="handleStatusClick"
            @search-input="handleSearchInput"
          />
        </b-col>
      </b-row>
      <data-table
        :items="items"
        :root-path-doc="rootpathdoc"
        :root-data-doc="rootdatadoc"
        @update-status-click="handleUpdateStatusClick"
        @update-fave-click="handleUpdateFaveClick"
      />
    </div>
    <add-edit-item-modal
      :ref="addEditItemModalId"
      :item-status-modal-id="addEditItemModalId"
      :profile="profile"
      :root-path-doc="rootpathdoc"
      @item-added="handleItemAdded"
    />
    <update-status-modal
      :ref="updateStatusModalId"
      :profile="profile"
      @item-status-updated="handleStatusUpdated"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import DataTable from "./dataTable";
import ButtonToolbar from "./buttonToolbar";
import AddEditItemModal from "./addEditItemModal";
import UpdateStatusModal from "./updateStatusModal";
export default {
  name: "Items_Forms",
  components: {
    AddEditItemModal,
    ButtonToolbar,
    DataTable,
    UpdateStatusModal
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    },
    rootpathdoc: {
      type: String,
      default: null
    },
    rootdatadoc: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({}),
    allFaves(){
      return [];
    },
    items() {
      if (this.searchStr.trim() == "" && !this.status) return this.allFaves;

      let filtered = [];
      let searchStrTrim = this.searchStr.trim() != "" ? this.searchStr.trim().toLowerCase() : null;

      filtered = this.allFaves.filter(anItem => {
        return (anItem.status == this.status || !this.status) &&
            (
                (anItem.slug &&  anItem.slug.toLowerCase().includes(searchStrTrim)) ||
                (anItem.form && anItem.form.name && anItem.form.name.toLowerCase().includes(searchStrTrim)) ||
                (anItem.form && anItem.form.description && JSON.stringify(anItem.form.description).toLowerCase().includes(searchStrTrim))
            );
      });

      return filtered;
    }
  },
  mounted() {},
  methods: {
    handleSearchInput(search) {
      this.searchStr = search;
    },
    handleStatusClick(status) {
      this.status = status;
    },
    handleActivation() {
      //lazy load only on selection. Prevent unecessary pulls and other benefits
      this.getFaves();
    },
    getFaves() {
      this.$store.dispatch("admin/getFaves").then(res => {
        console.log(res);
      });
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    handleAddItemClick() {
      if (this.$refs[this.addEditItemModalId].hasOwnProperty("handleAddItem")) {
        this.$refs[this.addEditItemModalId].handleAddItem();
      }
    },
    handleUpdateStatusClick(item) {
      if (
        this.$refs[this.updateStatusModalId].hasOwnProperty(
          "handleOpenStatusModalForItem"
        )
      ) {
        this.$refs[this.updateStatusModalId].handleOpenStatusModalForItem(item);
      }
    },
    handleUpdateFaveClick(item) {
      if (
        this.$refs[this.addEditItemModalId].hasOwnProperty("handleUpdateItem")
      ) {
        this.$refs[this.addEditItemModalId].handleUpdateItem(item);
      }
    },
    handleItemAdded(item) {
      this.$store.dispatch("user/showNotification", {
        title: `A Memory Added ${item && item.name ? item.name : ""} !'}`,
        description: `Your item has been added`,
        variant: "success"
      });
      this.getFaves();
    },
    handleStatusUpdated(updates) {
      this.$store.dispatch("user/showNotification", {
        title: `A Memory Status Updated`,
        description: `Your item has been ${updates.status}.`,
        variant: "success"
      });
      this.getFaves();
    }
  },
  data() {
    return {
      searchStr: "",
      status: null, //|all | submitted | needs_work | inactive
      addEditItemModalId: "add-edit-status-modal-fave",
      updateStatusModalId: "update-status-modal-fave",
      btnText: "Approve",
      transProps: {
        name: "flip-list" // Transition name
      },
      fields: [
        { key: "email", sortable: true, label: "Email" },
        { key: "ip_address", sortable: true, label: "IP Address " },
        {
          key: "_created_at",
          sortable: true,
          label: "Submitted",
          formatter: "formatDate"
        }
        // { key: "actions", label: "Actions" }
        //     { key: "show_details", label: "Show Details" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      selectedUser: {},
      showUserNotify: true
    };
  }
};
</script>
<style lang="scss" scoped>
.card-guide {
  box-shadow: none;
}
</style>
